<template>

  <span @click.prevent="onClick">
    <slot v-bind:light="light" v-bind:info="tooltipText" v-bind:count="failedJobs.length"></slot>
  </span>

</template>

<script>

import _ from 'lodash';
import moment from 'moment';
import { ApiUtil as api } from '@/utils/api.util.js'

export default {

  name: 'IntegrationServerTrafficLight',

  props: {
    //
  },

  data() {
    return {
      intervalRanAt: null, // null or unix milliseconds like Date.now()
      responsePayload: null,
      lastDataFetchedAt: null, // null or unix milliseconds like Date.now()
      lastAjaxFinishedAt: null, // null or unix milliseconds like Date.now()
      lastAjaxIntervalId: null,
    };
  },

  computed: {
    resultAvailable: function() {
      return (this.responsePayload && this.responsePayload.metrics) ? true : false;
    },
    failedJobs() {
      let failedJobs = [];
      if (this.resultAvailable) {
        failedJobs = this.responsePayload.dispatched_jobs.filter(dj => {
          return ( ! dj.successful_at)
        });
      }
      return failedJobs;
    },
    ajaxBusy: function() {
      return this.$store.getters['ajaxIsLoading'];
    },
    ajaxIsIdle: function() {
      return this.lastAjaxFinishedAt
        ? (this.intervalRanAt - this.lastAjaxFinishedAt >= 1000)
        : false;
    },
    isTimeToGetFreshData() {
      const ms_between = (60 * 5 * 1000); // seconds * minutes * milliseconds
      if (this.lastDataFetchedAt) {
        return (this.intervalRanAt - this.lastDataFetchedAt >= ms_between) ? true : false
      }
      else return true;
    },
    light() {
      let light = null;
      if (this.resultAvailable) {
         light = this.failedJobs.length ? 'red' : 'green';
      }
      return light;
    },
    tooltipText() {
      // Our current version of buefy doesn't support HTML content.
      let text = 'No data available.';
      if (this.resultAvailable) {
        const latestDispatchedJob = _.head(this.responsePayload.dispatched_jobs);
        if (latestDispatchedJob) {
          const friendly_description = _.get(latestDispatchedJob, 'friendly_description');
          const friendly_status = _.get(latestDispatchedJob, 'friendly_status');
          const count_attempts = _.get(latestDispatchedJob, 'count_attempts');
          const attempted_at = _.get(latestDispatchedJob, 'attempted_at');
          text = `Most recent was ${friendly_description} (${friendly_status}) with ${count_attempts} attempt(s).`;
          if (attempted_at) {
            const attempted_at_local = this.$options.filters.toLocalDateAndTime(attempted_at);
            text  = text + ` Last attempted at ${attempted_at_local}.`;
          }
        }
      }
      return text;
    }
  },

  watch: {
    ajaxBusy: function(next) {
      this.lastAjaxFinishedAt = next ? null : Date.now();
    }
  },

  mounted() {

    const vm = this;

    // If no ajax busy, assume it's done for now.
    // (we have a watcher to change ajaxBusy)
    if ( ! this.ajaxBusy) {
      this.lastAjaxFinishedAt = Date.now();
    }
    else {
      // Deliberately nothing. The ajaxBusy watcher will update
      // lastAjaxFinishedAt when computed value changes next.
    }

    // Set an interval to check when AJAX has been
    // quiet for a while so we can do some work.
    this.lastAjaxIntervalId = window.setInterval(
      function () {
        vm.intervalRanAt = Date.now();
        if (vm.ajaxIsIdle && vm.isTimeToGetFreshData) {
          vm.getSummaryData();
        }
      },
      1000
    );

  },

  beforeDestroy() {
    if (this.lastAjaxIntervalId) {
      window.clearInterval(this.lastAjaxIntervalId);
    }
  },

  methods: {
    getSummaryData() {
      const vm = this;
      const previousDataFetchedAt = this.lastDataFetchedAt; // to restore previous value on fetch error
      this.lastDataFetchedAt = Date.now();
      api.get('system/integration_server_status')
      .then(data => {
        this.responsePayload = data;
      })
      .catch(err => {
        console.log(err);
        vm.lastDataFetchedAt = previousDataFetchedAt;
      })
      .finally(() => {
        //
      });
    },
    onClick($event) {
      // NOTE: Could instead emit the full payload and allow parent component
      // to decide what to do with the click but not sure we'll need that.
      /*
      this.$emit('click', {
        //
      });
      */
      let url = _.get(this.responsePayload, 'meta.url_jobs_queue');
      url = url ? decodeURI(url) : url;
      if (url) {
        window.open(url, '_blank')
      }
      return;
    }
  }
};

</script>


// WEBPACK FOOTER //
// src/components/System/IntegrationServerTrafficLight.vue